import { h } from 'preact';
import React, { Component } from 'react';

import Accordion from '../Components/Accordion';
import PurposeContent from './PurposeContent';
import SpecialPurposeContent from './SpecialPurposeContent';
import StackToggle from './StackToggle';
import { StackTitle } from './StackTitle';
import { makeText } from '../../../util';

const StackContent = ({
  stack,
  selected,
  settings,
  togglePurposeOrFeature,
  toggleText,
  toggleOffText,
  force,
  updateMe,
  accordionOpen: parentAccordionOpen
}) => {
  return (
    <div className="purpose-content">
      <p style={{ ...settings.panelFont }} className="stack-description">{stack.description}</p>
      {stack.categories.map(c => (
        <StackToggle
          key={c._id}
          purpose={c}
          selected={selected}
          settings={settings}
          togglePurposeOrFeature={togglePurposeOrFeature}
          toggleText={toggleText}
          toggleOffText={toggleOffText}
          force={force}
          updateMe={updateMe}
          parentAccordionOpen={parentAccordionOpen}
        />
      ))}
    </div>
  );
};

export default class Purposes extends Component {
  state = {
    selected:  this.props.startWithLiToggled ? 'li' : 'consent',
    forceUpdate: true
  }
  force = () => this.setState({ forceUpdate: !this.state.forceUpdate })
  render() {
    const {
      stacks,
      useStacks,
      consentOnlyStacks,
      purposes,
      specialPurposes,
      settings,
      language,
      dev,
      usePurModel,
    } = this.props;
    const { selected } = this.state;

    const purposesText = makeText(Boolean(dev), settings, 'purposesText', language);
    const purposeInfoText = makeText(Boolean(dev), settings, 'purposeInfo', language);
    const customPurposesText = makeText(Boolean(dev), settings, 'customPurposesText', language);
    const specialPurposesText = makeText(Boolean(dev), settings, 'specialPurposesText', language);
    const specialPurposesInfoText = makeText(Boolean(dev), settings, 'specialPurposesInfo', language);
    const toggleText = makeText(Boolean(dev), settings, 'toggleText', language);
    const toggleOffText = makeText(Boolean(dev), settings, 'toggleOffText', language);
    const consentText = makeText(Boolean(dev), settings, 'consentText', language);
    const liText = makeText(Boolean(dev), settings, 'liText', language);
    const liInfo = makeText(Boolean(dev), settings, 'liInfo', language);
    const customPurposesLetter = makeText(Boolean(dev), settings, 'customPurposesLetter', language);

    /* Special Purposes in Legitimate Interest Only? */
    const specialOnly = selected === 'consent' && settings.specialOnly;

    /* GATHER STACKS */
    const stacksWithPurposes = stacks
      .filter(s => s.childCategories.length > 0)
      .map(s => {
        s.categories = s.childCategories.map(c => purposes.find(j => j._id === c)).filter(h => {
          if (h === undefined) return false;
          if (selected === 'consent' && h.requiringConsentVendors.length <= 0) return false;
          if (selected === 'li' && h.legIntVendors.length <= 0) return false;
          return true;
        });
        return s;
      });
    let foundPurposes = [];
    stacksWithPurposes.forEach(s => {
      const catIds = s.categories.map(c => c._id);
      foundPurposes = [...foundPurposes, ...catIds];
    });

    /* GATHER PURPOSES */
    const disclosureOnlyPurposes = [];
    let purposeOne = null;


    const actuallyUseStacks = selected === 'li' && consentOnlyStacks ? false : useStacks;
    const actualPurposes = purposes.filter(p => {
      if (p.disclosureOnly === true) {
        disclosureOnlyPurposes.push(p);
        return false;
      }
      if (selected === 'consent' && p.requiringConsentVendors.length <= 0) return false;
      if (selected === 'li' && p.legIntVendors.length <= 0) return false;
      if (actuallyUseStacks && p.iabId === 1) {
        purposeOne = p;
        return false;
      }
      if (actuallyUseStacks && foundPurposes.find(fp => fp === p._id)) return false;
      return true;
    });
    return (
      <div className="pm-purposes">
        <div className="pm-type-toggle">
          <div tabindex="0" title={consentText} aria-label={consentText} onClick={() => this.setState({ selected: 'consent' })} onKeyDown={(e) => e.keyCode === 13 && this.setState({ selected: 'consent' })}>{consentText}</div>
          <div tabindex="0" title={liText} aria-label={liText} onClick={() => this.setState({ selected: 'li' })} onKeyDown={(e) => e.keyCode === 13 && this.setState({ selected: 'li' })}>{liText}</div>
          <span className={selected === 'li' ? 'selected li' : 'selected consent'} />
        </div>

        <h3>{purposesText}</h3>
        <p className="pm-sub-p">{selected === 'consent' ? purposeInfoText : liInfo}</p>
        <div className="legend"><span className="legend-key">{customPurposesLetter}</span> {customPurposesText}</div>

        { /* LIST OUT STACKS AND PURPOSE ONE IF STACKS IS TRUE */}
        {actuallyUseStacks === true && (
          <div>
            {purposeOne !== null && (
              <Accordion
                key={`purpose-${purposeOne._id}`}
                settings={settings}
                name={<span>{purposeOne.name}{purposeOne.type !== 'IAB_PURPOSE' && <span className="legend-key inline">{customPurposesLetter}</span>}</span>}
                accessName={purposeOne.name}
                description={purposeOne.description}
                child="purposes"
                language={language}
                value={purposeOne}
                selected={selected}
                vendors={selected === 'consent' ? purposeOne.requiringConsentVendors : purposeOne.legIntVendors}
                content={<PurposeContent dev={dev} selected={selected} purpose={purposeOne} language={language} settings={settings} force={this.force} isCustom={purposeOne.type === 'CUSTOM'} />}
                toggle={this.props.togglePurposeOrFeature}
                updateMe={this.state.forceUpdate}
                dev={dev}
                usePurModel={usePurModel && this.state.selected !== 'li'}
              />
            )}
            {stacksWithPurposes.length > 0 && stacksWithPurposes.map(s => s.categories.length > 0 ? (
              <Accordion
                key={`stack-${s._id}`}
                settings={settings}
                accessName={s.name}
                child="purposes"
                language={language}
                value={s}
                titleContent={<StackTitle stack={s} selected={selected} toggleStack={this.props.toggleStack} language={language} settings={settings} dev={dev} />}
                content={<StackContent stack={s} selected={selected} settings={settings} togglePurposeOrFeature={this.props.togglePurposeOrFeature} toggleText={toggleText} toggleOffText={toggleOffText} language={language} force={this.force} updateMe={this.state.forceUpdate} dev={dev} isCustom={s.type === 'CUSTOM'} />}
                toggle={false}
                force={this.force}
                updateMe={this.state.forceUpdate}
                dev={dev}
                usePurModel={usePurModel && this.state.selected !== 'li'}
              />
            ) : null)}
          </div>
        )}

        { /* LIST OUT THE ACTUAL FILTERED LIST OF PURPOSES BASED ON STACKS AND OTHER REASONS */}
        {actualPurposes.map(p => (
          <Accordion
            key={`purpose-${p._id}`}
            settings={settings}
            name={<span>{p.name}{p.type !== 'IAB_PURPOSE' && <span className="legend-key inline">{customPurposesLetter}</span>}</span>}
            accessName={p.name}
            description={p.description}
            child="purposes"
            language={language}
            value={p}
            selected={selected}
            vendors={selected === 'consent' ? p.requiringConsentVendors : p.legIntVendors}
            content={<PurposeContent selected={selected} purpose={p} language={language} settings={settings} force={this.force} dev={dev} isCustom={p.type === 'CUSTOM'} />}
            toggle={this.props.togglePurposeOrFeature}
            updateMe={this.state.forceUpdate}
            dev={dev}
            usePurModel={usePurModel && this.state.selected !== 'li'}
          />
        ))}

        { /* LIST OUT SPECIAL PURPOSES */}
        {(specialPurposes.length > 0 || disclosureOnlyPurposes.length > 0) && !specialOnly && <h3>{specialPurposesText}</h3>}
        {(specialPurposes.length > 0 || disclosureOnlyPurposes.length > 0) && !specialOnly && <p className="pm-sub-p">{specialPurposesInfoText}</p>}
        {specialPurposes.length > 0 && !specialOnly && specialPurposes.map(p => (
          <Accordion
            key={`special-purpose-${p._id}`}
            settings={settings}
            name={p.name}
            accessName={p.name}
            child="specialPurposes"
            language={language}
            value={p}
            selected={selected}
            description={p.description}
            content={<SpecialPurposeContent purpose={p} language={language} settings={settings} force={this.force} dev={dev} isCustom={p.type === 'CUSTOM'} />}
            updateMe={this.state.forceUpdate}
            dev={dev}
            usePurModel={usePurModel && this.state.selected !== 'li'}
          />
        ))}

        { /* LIST OUT DISCOLSURE ONLY PURPOSES */}
        {disclosureOnlyPurposes.length > 0 && disclosureOnlyPurposes.map(p => (
          <Accordion
            key={`purpose-${p._id}`}
            settings={settings}
            name={<span>{p.name}<span className="legend-key inline">{customPurposesLetter}</span></span>}
            accessName={p.name}
            description={p.description}
            child="purposes"
            language={language}
            value={p}
            selected={selected}
            content={<PurposeContent disclosure={true} selected={selected} purpose={p} language={language} settings={settings} force={this.force} dev={dev} isCustom={p.type === 'CUSTOM'} />}
            toggle={false}
            updateMe={this.state.forceUpdate}
            dev={dev}
            usePurModel={usePurModel && this.state.selected !== 'li'}
          />
        ))}
      </div>
    );
  }
}
